import React from 'react';

type Props = {
  className?: string;
};

const StoneberryIcon: React.FC<Props> = ({ className }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 64 64" className={className}>
    <path fill="#112F4F" d="M32.007 13.15l-18.85 18.86 18.85 18.86 18.85-18.86-18.85-18.86z"></path>
    <path fill="#76C5B3" d="M50.858 32.01l2.545 13.13L34.553 64l-2.546-13.13 18.851-18.86z"></path>
    <path fill="#1974B9" d="M13.156 32.01l-2.56-13.149L29.446 0l2.561 13.149-18.85 18.86z"></path>
    <path fill="#F2B5B6" d="M32.008 50.87L18.85 53.434 0 34.572l13.156-2.562 18.851 18.86z"></path>
    <path fill="#F8BB16" d="M32.008 13.149l13.141-2.547L64 29.463 50.858 32.01l-18.85-18.861z"></path>
  </svg>
);

export default StoneberryIcon;
